import React, { useState, useEffect } from "react";
import Layout from "../../Components/Layout/layout";
import dashboardclasses from "../dashboard.module.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.css";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import BootstrapTable from "react-bootstrap-table-next";
import moment from "moment";
import "../../App.css";
import { Services } from "../../Services";
import Addbanners from "./addslots";
import { css } from "@emotion/react";
import ScaleLoader from "react-spinners/ScaleLoader";
import { useNavigate } from "react-router-dom";
import { ToastError } from "../../Components/utils/ToastMessage";
import { FaRegEdit } from "react-icons/fa";
function Warehouse() {
    const Navigate = useNavigate();
    const dummy = [{ text: "2" }];
    const [tableLoad, setTableLoad] = useState(false);
    const [category, setCategory] = useState(false);
    const [CategorySearchItems, setCategorySearchItems] = useState([]);

    const [editable, setEditable] = useState(false);
    const [categoryItems, setCategoryItems] = useState([]);
    const [slotId, setSlotId] = useState();
    let [loading, setLoading] = useState(true);
    const [Navactive, setNavactive] = useState(1);
    const token = { Authorization: `token ${sessionStorage.getItem("token")}` };
    const categoryHandler = () => {
        setCategory((prev) => !prev);
    };
    const headerstyles = {
        color: "#707275",
        fontWeight: 700,
        fontSize: "0.8rem",
    };
    const override = css`
        display: block;
        margin: 0 auto;
        border-color: red;
    `;
    const getcategories = (id) => {
        Services.Admin_Settings("GET", null, token, id)
            .then((res) => {
                if (res.Status === 1) {
                    setCategoryItems(res.TimeSlots);
                    setCategorySearchItems(res.TimeSlots);
                    setTableLoad(false);
                    setLoading(false);
                } else if (res.Status === 0) {
                    ToastError(res.Message);
                    if (res.Message === "Token expired") {
                        Navigate("/");
                    }
                }
            })
            .catch((err) => {
                // alert(err);
                alert("something went wrong please try again");
                console.log(err);
                setTableLoad(false);
            });
    };
    useEffect(() => {
        getcategories(Navactive);

        // eslint-disable-next-line
    }, []);
    const slotsFormatter = (rowItem) => {
        const resultString = rowItem
            ?.map((slot, index) => {
                const slotNumber = index + 1;
                return `slot${slotNumber}:${slot.Slot}`;
            })
            .join(" ,");
        return resultString;
    };
    const editHandler = (rowItem, row) => {
        return (
            <div className={dashboardclasses.tablebtns}>
                <button
                    onClick={() => {
                        setCategory(true);
                        setSlotId(row.TimeSlotID);
                        setEditable(true);
                    }}>
                    <FaRegEdit size={18} />
                </button>
            </div>
        );
    };
    let columns = [
        {
            dataField: "City",
            text: "City",
            // formatter: slotsFormatter,
            sort: false,
            headerStyle: () => {
                return { ...headerstyles };
            },
        },
        {
            dataField: "Today",
            text: "Today",
            formatter: slotsFormatter,
            sort: false,
            headerStyle: () => {
                return { ...headerstyles };
            },
        },
        {
            dataField: "Tommorrow",
            text: "Tommorrow",
            formatter: slotsFormatter,
            sort: false,
            headerStyle: () => {
                return { ...headerstyles };
            },
        },
        {
            dataField: "DayAfter",
            text: "DayAfter",
            formatter: slotsFormatter,
            sort: false,
            headerStyle: () => {
                return { ...headerstyles };
            },
        },
        {
            dataField: "EDIT",
            text: "EDIT",
            formatter: editHandler,
            sort: false,
            headerStyle: () => {
                return { ...headerstyles };
            },
        },
    ];
    // if (Navactive == 2) {
    //     columns = columns.filter((column) => column.dataField != "City");
    // }
    const defaultSorted = [
        {
            dataField: "name",
            order: "desc",
        },
    ];
    const searchHandler = (e) => {
        const search = categoryItems.filter((item) =>
            item.City.toLowerCase().includes(e.target.value.toLowerCase())
        );
        // console.log(search);
        setCategorySearchItems(search);
    };
    const navactivehandler = (e) => {
        let status = e.currentTarget.getAttribute("id");
        setNavactive(status);
        setLoading(true);
        getcategories(status);
    };

    return (
        <>
            {category && (
                <Addbanners
                    setmodal={setCategory}
                    categoryItems={categoryItems}
                    editable={editable}
                    setEditable={setEditable}
                    getCategories={getcategories}
                    Navactive={Navactive}
                    tableload={setTableLoad}
                    TimeSlotID={slotId}
                />
            )}

            <Layout Active={"Slots"}>
                <div className={dashboardclasses["dashboard-rightside"]}>
                    <div className={dashboardclasses.CategoryWrapper}>
                        <h3>Slots</h3>
                        <div className={dashboardclasses["orders-navbar"]}>
                            <button
                                id="1"
                                className={
                                    Navactive == 1 &&
                                    dashboardclasses["order-active"]
                                }
                                onClick={navactivehandler}>
                                Grocery
                            </button>
                            <button
                                id="2"
                                className={
                                    Navactive == 2 &&
                                    dashboardclasses["order-active"]
                                }
                                onClick={navactivehandler}>
                                Service
                            </button>
                        </div>

                        {loading ? (
                            <div className={dashboardclasses["loader"]}>
                                <ScaleLoader
                                    color={"black"}
                                    loading={true}
                                    css={override}
                                    size={150}
                                />
                            </div>
                        ) : (
                            <>
                                {tableLoad ? (
                                    <div className={dashboardclasses["loader"]}>
                                        <ScaleLoader
                                            color={"black"}
                                            loading={true}
                                            css={override}
                                            size={150}
                                        />
                                    </div>
                                ) : (
                                    <div className="category-table">
                                        <div
                                            className={
                                                dashboardclasses[
                                                    "category-form-two"
                                                ]
                                            }>
                                            <input
                                                type={"text"}
                                                placeholder="search by name"
                                                onChange={searchHandler}
                                            />
                                            <button onClick={categoryHandler}>
                                                + Add Slot
                                            </button>
                                        </div>
                                        <BootstrapTable
                                            bootstrap4
                                            keyField="id"
                                            data={CategorySearchItems}
                                            columns={columns}
                                            defaultSorted={defaultSorted}
                                            wrapperClasses="table-responsive"
                                        />
                                    </div>
                                )}
                            </>
                        )}
                    </div>
                </div>
            </Layout>
        </>
    );
}

export default Warehouse;
